import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { FullPageLoader } from '../components/ui/FullPageLoader';

import { useAuth } from './AuthContext';

/** Gate for authenticated routes. Preserves the attempted location so login
 * can bounce the coach back to where they were headed. */
export function ProtectedRoute(): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageLoader label="Restoring your session…" />;
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
